import "@/utils";
import "@/api";
import "@/components";
import Vue from "vue";
import echarts from "echarts";
import moment from "moment";

import "@/styles/index.less";
import "@/styles/common.less";

import store from "./store";
import router from "./router";
import App from "./App.vue";
import * as filters from "./utils/filters";

Object.entries(filters).forEach(([key, filter]) => {
  Vue.filter(key, filter);
});
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;

new Vue({ store, router, render: (h) => h(App) }).$mount("#app");
